<template>
  <div class="salary-container">
    <van-nav-bar
      title="工资条"
      @click-left="$router.push('/')"
      left-arrow
      safe-area-inset-top
      placeholder
    />
    
    <!-- 搜索和操作区域 -->
    <div class="controls-container">
      <!-- <van-search
        v-model="searchValue"
        placeholder="搜索姓名、公司或月份"
        shape="round"
        @search="onSearch"
        @clear="onClearSearch"
      />
      <div class="action-buttons">
        <van-button 
          size="small" 
          type="primary" 
          @click="expandAll"
          icon="plus"
        >
          全部展开
        </van-button>
        <van-button 
          size="small" 
          type="default" 
          @click="collapseAll"
          icon="minus"
        >
          全部收起
        </van-button>
        <van-button 
          size="small" 
          type="info" 
          @click="toggleSummaryMode"
          icon="eye"
        >
          {{ summaryMode ? '详细模式' : '摘要模式' }}
        </van-button>
      </div> -->
    </div>
    
    <!-- 摘要统计（摘要模式下显示） -->
    <div class="summary-stats" v-if="summaryMode && filteredRecords.length > 0">
      <van-grid :column-num="3" :border="false">
        <van-grid-item>
          <div class="stat-item">
            <div class="stat-label">总人数</div>
            <div class="stat-value">{{ filteredRecords.length }}</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="stat-item">
            <div class="stat-label">实发总额</div>
            <div class="stat-value total">{{ calculateTotalSalary() }}</div>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="stat-item">
            <div class="stat-label">平均工资</div>
            <div class="stat-value average">{{ calculateAverageSalary() }}</div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    
    <div class="box_container">
      <block v-if="filteredRecords.length > 0">
        <van-collapse 
          v-model="activeNames"
          :border="false"
          class="salary-collapse"
          accordion
        >
          <van-collapse-item 
            v-for="(item, index) of filteredRecords" 
            :key="index"
            :name="index"
            class="salary-item"
          >
            <!-- 折叠头部 - 只显示关键信息 -->
            <template #title>
              <div class="collapse-header">
                <div class="user-avatar">
                  {{ getAvatarText(item.userName) }}
                </div>
                <div class="user-info">
                  <div class="user-name">{{ item.userName }}</div>
                  <div class="user-subtitle">
                    <van-tag size="mini" type="primary">{{ item.month }}</van-tag>
                    <span class="company">{{ item.storeName }}</span>
                  </div>
                </div>
                <div class="salary-summary">
                  <div class="salary-breakdown">
                    <span class="breakdown-item">
                      <span class="label">应发:</span>
                      <span class="value">{{ item.grossSalary || '0.00' }}</span>
                    </span>
                    <span class="breakdown-item">
                      <span class="label">实发:</span>
                      <span class="value real">{{ item.taxedSalary || '0.00' }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            
            <!-- 折叠内容 - 完整工资详情 -->
            <div class="collapse-content" v-if="!summaryMode">
              <!-- 基本信息 -->
              <div class="detail-section">
                <h4 class="section-title">
                  <van-icon name="user-circle-o" />
                  基本信息
                </h4>
                <van-grid :column-num="2" :border="false" class="info-grid">
                  <van-grid-item>
                    <div class="grid-label">姓名</div>
                    <div class="grid-value">{{ item.userName }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">月份</div>
                    <div class="grid-value">{{ item.month }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">身份证号</div>
                    <div class="grid-value">{{ formatIdCard(item.idCard) }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">主体公司</div>
                    <div class="grid-value">{{ item.storeName }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">工龄(月)</div>
                    <div class="grid-value">{{ item.workMonth }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">社保缴纳</div>
                    <div class="grid-value">
                      <van-tag 
                        :type="item.socialSecurity == 1 ? 'success' : 'danger'"
                        size="small"
                      >
                        {{ item.socialSecurity == 0 ? '否' : item.socialSecurity == 1 ? '是' : '-' }}
                      </van-tag>
                    </div>
                  </van-grid-item>
                </van-grid>
              </div>
              
              <!-- 工资构成 -->
              <div class="detail-section">
                <h4 class="section-title">
                  <van-icon name="gold-coin-o" />
                  工资构成
                </h4>
                
                <!-- 基本工资 -->
                <div class="subsection">
                  <h5 class="subsection-title">基本工资</h5>
                  <van-grid :column-num="2" :border="false">
                    <van-grid-item>
                      <div class="grid-label">基本工资</div>
                      <div class="grid-value amount">{{ item.basicSalary }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">浮动绩效</div>
                      <div class="grid-value amount">{{ item.meritSalary }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">岗位工资</div>
                      <div class="grid-value amount">{{ item.postSalary }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">补贴金额</div>
                      <div class="grid-value amount">{{ item.bonusSalary }}</div>
                    </van-grid-item>
                  </van-grid>
                </div>
                
                <!-- 其他收入 -->
                <div class="subsection">
                  <h5 class="subsection-title">其他收入</h5>
                  <van-grid :column-num="2" :border="false">
                    <van-grid-item>
                      <div class="grid-label">兼职工资</div>
                      <div class="grid-value amount">{{ item.partimeSalary }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">兼职补贴</div>
                      <div class="grid-value amount">{{ item.partimeBonus }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">加班工资</div>
                      <div class="grid-value amount">{{ item.extraWorkSalary }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">服务激励</div>
                      <div class="grid-value amount">{{ item.incentiveSalary }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">住房津贴</div>
                      <div class="grid-value amount">{{ item.housingSubsidy }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">特别调整（加项）</div>
                      <div class="grid-value amount">{{ item.specialAdjust }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">计税奖金（专用）</div>
                      <div class="grid-value amount">{{ item.taxBonus }}</div>
                    </van-grid-item>
                  </van-grid>
                </div>
                
                <!-- 扣款项 -->
                <div class="subsection">
                  <h5 class="subsection-title">扣款项</h5>
                  <van-grid :column-num="2" :border="false">
                    <van-grid-item>
                      <div class="grid-label">扣款金额</div>
                      <div class="grid-value amount negative">{{ item.deductSalary }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">兼职扣款</div>
                      <div class="grid-value amount negative">{{ item.partimeDeduct }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">入离职扣款</div>
                      <div class="grid-value amount negative">{{ item.departDeduct }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">请假扣款</div>
                      <div class="grid-value amount negative">{{ item.askLeaveDeduct }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">固定扣款（外包专用）</div>
                      <div class="grid-value amount negative">{{ item.staticDeduct }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">其他扣款</div>
                      <div class="grid-value amount negative">{{ item.otherDeduct }}</div>
                    </van-grid-item>
                    <van-grid-item>
                      <div class="grid-label">特别调整扣款</div>
                      <div class="grid-value amount negative">{{ item.specialAdjustDeduct }}</div>
                    </van-grid-item>
                  </van-grid>
                </div>
                
                <!-- 小计部分 -->
                <div class="subtotals">
                  <div class="subtotal-row">
                    <span class="label">小计(A)</span>
                    <span class="value">{{ item.countA }}</span>
                  </div>
                  <div class="subtotal-row">
                    <span class="label">小计(B)</span>
                    <span class="value">{{ item.countB }}</span>
                  </div>
                  <div class="subtotal-row">
                    <span class="label">小计(C)</span>
                    <span class="value">{{ item.countC }}</span>
                  </div>
                  <div class="subtotal-row">
                    <span class="label">小计(D)</span>
                    <span class="value negative">{{ item.countD }}</span>
                  </div>
                </div>
              </div>
              
              <!-- 社保与公积金 -->
              <div class="detail-section">
                <h4 class="section-title">
                  <van-icon name="shield-o" />
                  社保与公积金
                </h4>
                <van-grid :column-num="2" :border="false">
                  <van-grid-item>
                    <div class="grid-label">养老保险个人</div>
                    <div class="grid-value amount negative">{{ item.oldAgeInsurance }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">医疗保险个人</div>
                    <div class="grid-value amount negative">{{ item.medicalInsurance }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">大病医疗保险个人</div>
                    <div class="grid-value amount negative">{{ item.seriousMedicalInsurance }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">失业保险个人</div>
                    <div class="grid-value amount negative">{{ item.joblessInsurance }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">住房公积金个人</div>
                    <div class="grid-value amount negative">{{ item.housingFund }}</div>
                  </van-grid-item>
                </van-grid>
                
                <div class="insurance-totals">
                  <div class="total-row">
                    <span class="label">五险个人合计</span>
                    <span class="value negative">{{ item.insuranceAmount }}</span>
                  </div>
                  <div class="total-row">
                    <span class="label">五险一金个人合计</span>
                    <span class="value negative">{{ item.fundAmount }}</span>
                  </div>
                </div>
              </div>
              
              <!-- 税务信息 -->
              <div class="detail-section">
                <h4 class="section-title">
                  <van-icon name="balance-list-o" />
                  税务信息
                </h4>
                <van-grid :column-num="2" :border="false">
                  <van-grid-item>
                    <div class="grid-label">税前工资</div>
                    <div class="grid-value">{{ item.untaxSalary }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">个税</div>
                    <div class="grid-value amount negative">{{ item.tax }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">应补（退）税额</div>
                    <div class="grid-value amount">{{ item.taxSupply }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">个税差额调整</div>
                    <div class="grid-value amount">{{ item.taxAdjust }}</div>
                  </van-grid-item>
                </van-grid>
              </div>
              
              <!-- 最终发放 -->
              <div class="detail-section">
                <h4 class="section-title">
                  <van-icon name="cash-on-deliver" />
                  最终发放
                </h4>
                <div class="final-amounts">
                  <div class="final-row">
                    <span class="label">实发工资</span>
                    <span class="value large positive">{{ item.taxedSalary }}</span>
                  </div>
                  <div class="final-row">
                    <span class="label">税后奖金（专用）</span>
                    <span class="value positive">{{ item.taxedBonus }}</span>
                  </div>
                  <div class="final-row">
                    <span class="label">代补款</span>
                    <span class="value">{{ item.pendingPayment }}</span>
                  </div>
                  <div class="final-row">
                    <span class="label">代扣款</span>
                    <span class="value negative">{{ item.pendingDeduct }}</span>
                  </div>
                  <div class="final-row">
                    <span class="label">税后调整合计</span>
                    <span class="value">{{ item.taxedAdjustAmount }}</span>
                  </div>
                </div>
                
                <div class="bank-transfer">
                  <div class="transfer-row highlight">
                    <span class="label">银行汇款金额</span>
                    <span class="value large positive">{{ item.bankAmount }}</span>
                  </div>
                </div>
              </div>
              
              <!-- 平台费用 -->
              <div class="detail-section">
                <h4 class="section-title">
                  <van-icon name="shop-o" />
                  平台费用
                </h4>
                <van-grid :column-num="2" :border="false">
                  <van-grid-item>
                    <div class="grid-label">报销</div>
                    <div class="grid-value amount">{{ item.reimbursement }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">平台费用</div>
                    <div class="grid-value amount negative">{{ item.platformFee }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">平台手续费（3%）</div>
                    <div class="grid-value amount negative">{{ item.platformRate3 }}</div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="grid-label">平台手续费（7%）</div>
                    <div class="grid-value amount negative">{{ item.platformRate7 }}</div>
                  </van-grid-item>
                </van-grid>
                
                <div class="platform-totals">
                  <div class="total-row">
                    <span class="label">平台应付总额</span>
                    <span class="value">{{ item.platformPayAmount }}</span>
                  </div>
                  <div class="total-row highlight">
                    <span class="label">工资总额</span>
                    <span class="value large">{{ item.totalAmount }}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 摘要模式下的简化内容 -->
            <div class="collapse-content summary-content" v-else>
              <div class="summary-grid">
                <van-grid :column-num="3" :border="false">
                  <van-grid-item>
                    <div class="summary-item">
                      <div class="summary-label">应发工资</div>
                      <div class="summary-value">{{ item.grossSalary }}</div>
                    </div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="summary-item">
                      <div class="summary-label">社保公积金</div>
                      <div class="summary-value negative">{{ item.fundAmount }}</div>
                    </div>
                  </van-grid-item>
                  <van-grid-item>
                    <div class="summary-item">
                      <div class="summary-label">个税</div>
                      <div class="summary-value negative">{{ item.tax }}</div>
                    </div>
                  </van-grid-item>
                </van-grid>
              </div>
              <div class="final-summary">
                <div class="final-summary-item">
                  <span class="label">实发工资</span>
                  <span class="value positive">{{ item.taxedSalary }}</span>
                </div>
                <div class="final-summary-item">
                  <span class="label">银行汇款</span>
                  <span class="value positive">{{ item.bankAmount }}</span>
                </div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </block>
      
      <van-empty description="暂无工资条数据" v-else-if="result.records.length === 0" />
      <van-empty description="未找到匹配的工资条" v-else />
    </div>
    
    <div class="page" v-if="result.total > 1">
      <van-pagination
        v-model="currentPage"
        :total-items="result.total"
        :show-page-size="3"
        force-ellipses
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import { salaryList } from "@/api/index";
import { Search, Collapse, CollapseItem, Tag, Grid, GridItem, Button, Icon } from 'vant';

export default {
  name: "SalaryFoldableFull",
  components: {
    [Search.name]: Search,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tag.name]: Tag,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      searchValue: "",
      formData: {
        pageSize: 5,
      },
      result: {},
      currentPage: 1,
      activeNames: [], // 当前展开的面板
      summaryMode: false, // 摘要模式开关
    };
  },
  created() {
    this.init();
  },
  computed: {
    filteredRecords() {
      if (!this.searchValue.trim()) {
        return this.result.records || [];
      }
      
      const searchTerm = this.searchValue.toLowerCase();
      return (this.result.records || []).filter(item => {
        return (
          (item.userName && item.userName.toLowerCase().includes(searchTerm)) ||
          (item.storeName && item.storeName.toLowerCase().includes(searchTerm)) ||
          (item.month && item.month.toLowerCase().includes(searchTerm))
        );
      });
    }
  },
  methods: {
    init() {
      salaryList(this.formData).then((res) => {
        if (res.data.success) {
          this.result = res.data.result;
          // 默认全部折叠
          this.activeNames = [];
        }
      });
    },
    change(e) {
      this.formData.pageNo = e;
      this.init();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    onSearch() {
      console.log('搜索:', this.searchValue);
    },
    onClearSearch() {
      this.searchValue = "";
    },
    expandAll() {
      this.activeNames = this.filteredRecords.map((_, index) => index);
    },
    collapseAll() {
      this.activeNames = [];
    },
    toggleSummaryMode() {
      this.summaryMode = !this.summaryMode;
    },
    getAvatarText(name) {
      if (!name) return "?";
      return name.length >= 2 ? name.slice(-2) : name;
    },
    formatIdCard(idCard) {
      if (!idCard || idCard.length < 15) return idCard;
      return idCard.substring(0, 6) + '****' + idCard.substring(idCard.length - 4);
    },
    calculateTotalSalary() {
      if (!this.filteredRecords.length) return '0.00';
      const total = this.filteredRecords.reduce((sum, item) => {
        return sum + (parseFloat(item.taxedSalary) || 0);
      }, 0);
      return total.toFixed(2);
    },
    calculateAverageSalary() {
      if (!this.filteredRecords.length) return '0.00';
      const total = parseFloat(this.calculateTotalSalary());
      return (total / this.filteredRecords.length).toFixed(2);
    }
  },
};
</script>

<style lang="less" scoped>
.salary-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
  min-height: 100vh;
  padding-bottom: 20px;
}

/deep/ .van-nav-bar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);

  .van-nav-bar__title {
    color: #fff;
    font-weight: 600;
    font-size: 18px;
  }
}

/deep/ .van-nav-bar__left {
  .van-icon {
    color: #fff;
    font-size: 20px;
  }
}

// 控制区域
.controls-container {
  padding: 12px 16px;
  // background: #fff;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  .action-buttons {
    display: flex;
    gap: 8px;
    margin-top: 12px;
    
    .van-button {
      flex: 1;
      font-size: 12px;
    }
  }
}

// 摘要统计
.summary-stats {
  padding: 12px 16px;
  background: #fff;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  .stat-item {
    text-align: center;
    
    .stat-label {
      font-size: 12px;
      color: #666;
      margin-bottom: 4px;
    }
    
    .stat-value {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      
      &.total {
        color: #52c41a;
      }
      
      &.average {
        color: #1890ff;
      }
    }
  }
}

.box_container {
  padding: 0 16px;
}

// 折叠面板样式
.salary-collapse {
  /deep/ .van-collapse-item {
    margin-bottom: 12px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .van-collapse-item__wrapper {
      overflow: hidden;
    }
    
    .van-collapse-item__content {
      padding: 0;
      background-color: #f9fafc;
    }
  }
  
  /deep/ .van-collapse-item__title {
    padding: 16px;
    background: #fff;
    
    .van-cell__right-icon {
      font-size: 18px;
      color: #667eea;
    }
  }
}

// 折叠头部
.collapse-header {
  display: flex;
  align-items: center;
  width: 100%;
}

.user-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  margin-right: 12px;
  flex-shrink: 0;
}

.user-info {
  flex: 1;
  
  .user-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
  }
  
  .user-subtitle {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .van-tag {
      font-size: 10px;
      padding: 2px 6px;
    }
    
    .company {
      font-size: 13px;
      color: #666;
    }
  }
}

.salary-summary {
  text-align: right;
  flex-shrink: 0;
  
  .salary-breakdown {
    display: flex;
    flex-direction: column;
    gap: 4px;
    
    .breakdown-item {
      display: block;
      
      .label {
        font-size: 11px;
        color: #999;
        margin-right: 4px;
      }
      
      .value {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        
        &.real {
          color: #52c41a;
        }
      }
    }
  }
}

// 折叠内容
.collapse-content {
  padding: 16px;
}

.detail-section {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .section-title {
    font-size: 15px;
    font-weight: 600;
    color: #667eea;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(102, 126, 234, 0.1);
    display: flex;
    align-items: center;
    gap: 8px;
    
    .van-icon {
      font-size: 18px;
    }
  }
}

// 基本信息网格
.info-grid {
  /deep/ .van-grid-item {
    padding: 8px 0;
    
    .grid-label {
      font-size: 12px;
      color: #666;
      margin-bottom: 4px;
    }
    
    .grid-value {
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
  }
}

// 子章节
.subsection {
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .subsection-title {
    font-size: 14px;
    font-weight: 600;
    color: #555;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #1890ff;
  }
}

// 金额样式
.amount {
  color: #52c41a !important;
  
  &.negative {
    color: #f56c6c !important;
  }
}

// 小计部分
.subtotals {
  margin-top: 16px;
  padding: 12px;
  background: rgba(102, 126, 234, 0.05);
  border-radius: 8px;
  
  .subtotal-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.05);
    
    &:last-child {
      border-bottom: none;
    }
    
    .label {
      font-size: 14px;
      font-weight: 500;
      color: #666;
    }
    
    .value {
      font-size: 15px;
      font-weight: 600;
      color: #52c41a;
      
      &.negative {
        color: #f56c6c;
      }
    }
  }
}

// 保险总计
.insurance-totals, .platform-totals {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  
  .total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    
    &.highlight {
      padding: 12px;
      background: rgba(102, 126, 234, 0.05);
      border-radius: 6px;
      margin-top: 8px;
    }
    
    .label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
    
    .value {
      font-size: 15px;
      font-weight: 600;
      
      &.negative {
        color: #f56c6c;
      }
      
      &.large {
        font-size: 18px;
      }
    }
  }
}

// 最终金额
.final-amounts {
  .final-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.05);
    
    &:last-child {
      border-bottom: none;
    }
    
    .label {
      font-size: 14px;
      color: #666;
    }
    
    .value {
      font-size: 15px;
      font-weight: 600;
      
      &.positive {
        color: #52c41a;
      }
      
      &.negative {
        color: #f56c6c;
      }
      
      &.large {
        font-size: 18px;
      }
    }
  }
}

// 银行转账
.bank-transfer {
  margin-top: 16px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 8px;
  
  .transfer-row {
    &.highlight {
      .label {
        font-size: 16px;
        font-weight: 600;
        color: #667eea;
      }
      
      .value {
        font-size: 20px;
        color: #52c41a;
      }
    }
  }
}

// 摘要模式内容
.summary-content {
  .summary-grid {
    margin-bottom: 16px;
    
    .summary-item {
      text-align: center;
      
      .summary-label {
        font-size: 12px;
        color: #666;
        margin-bottom: 4px;
      }
      
      .summary-value {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        
        &.negative {
          color: #f56c6c;
        }
      }
    }
  }
  
  .final-summary {
    padding: 16px;
    background: rgba(102, 126, 234, 0.05);
    border-radius: 8px;
    
    .final-summary-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      
      &:first-child {
        border-bottom: 1px dashed rgba(0, 0, 0, 0.05);
      }
      
      .label {
        font-size: 14px;
        color: #666;
      }
      
      .value {
        font-size: 16px;
        font-weight: 600;
        color: #52c41a;
      }
    }
  }
}

// 分页
.page {
  padding: 20px 16px;
  background: #fff;
  margin-top: 10px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  
  /deep/ .van-pagination {
    justify-content: center;
    
    .van-pagination__item {
      background-color: #f5f7fa;
      border: 1px solid #e4edf5;
      color: #667eea;
      font-weight: 500;
      
      &.van-pagination__item--active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        border-color: #667eea;
      }
    }
  }
}

// 移动端适配
@media (max-width: 768px) {
  .box_container {
    padding: 0 12px;
  }
  
  .controls-container {
    padding: 10px 12px;
    
    .action-buttons {
      flex-wrap: wrap;
      
      .van-button {
        flex: 0 0 calc(33.333% - 6px);
      }
    }
  }
  
  .summary-stats {
    padding: 10px 12px;
  }
  
  .collapse-header {
    .user-avatar {
      width: 40px;
      height: 40px;
      font-size: 14px;
    }
    
    .user-name {
      font-size: 15px;
    }
    
    .salary-summary .salary-breakdown .breakdown-item .value {
      font-size: 13px;
    }
  }
  
  .collapse-content {
    padding: 12px;
  }
  
  .detail-section {
    padding: 12px;
  }
  
  .page {
    padding: 16px 12px;
  }
  
  /deep/ .van-grid {
    .van-grid-item__content {
      padding: 8px 4px;
    }
  }
}

// 动画
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.salary-item {
  animation: fadeIn 0.3s ease-out;
}
</style>